<template>
    <CContainer class="d-flex content-center min-vh-100">
        <div>
            <img src="../../../public/logo_1.png" alt="" class="login-logo" />
            <h1>Distributor Application Form</h1>
            <hr />
            <CForm
                v-on:submit.prevent="onSubmit"
                class="register-form"
                v-if="!saveSuccess"
            >
                <h3>
                    Please complete this application to become a distributor
                </h3>
                <p>
                    Note: If you wish to place a one time order of product in
                    bulk and you are looking for special pricing, please contact
                    us at 1-800-444-3310 and one of our agents will be happy to
                    assist you. Leveraging 25 years of experience in developing
                    innovative products to make your life and job easier.
                </p>
                <h3>Contact Information</h3>
                <CRow>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="userName"
                            id="userName"
                            label="Preferred User Name*"
                            v-model="newUser.userName"
                            :invalid-feedback="errors['userName'] || 'Required'"
                            :is-valid="
                                isLengthValid(
                                    newUser.userName,
                                    MAX_LENGTHS.userName
                                ) && !errors.hasOwnProperty('userName')
                            "
                            required
                            @input="delete errors.lastName"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="firstName"
                            id="firstName"
                            label="Primary Contact First Name*"
                            v-model="newUser.firstName"
                            :invalid-feedback="
                                errors['firstName'] || 'Required'
                            "
                            :is-valid="
                                isLengthValid(
                                    newUser.firstName,
                                    MAX_LENGTHS.firstName
                                ) && !errors.hasOwnProperty('firstName')
                            "
                            required
                            @input="delete errors.lastName"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="lastName"
                            id="lastName"
                            label="Primary Contact Last Name*"
                            v-model="newUser.lastName"
                            :invalid-feedback="errors['lastName'] || 'Required'"
                            :is-valid="
                                isLengthValid(
                                    newUser.lastName,
                                    MAX_LENGTHS.lastName
                                ) && !errors.hasOwnProperty('lastName')
                            "
                            required
                            @input="delete errors.lastName"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="email"
                            id="email"
                            label="Primary Email Address*"
                            type="email"
                            autocomplete="email"
                            :invalid-feedback="errors['email'] || 'Required'"
                            v-model="newUser.email"
                            :is-valid="
                                isValidEmail(newUser.email) &&
                                    !errors.hasOwnProperty('email')
                            "
                            required
                            @input="delete errors.email"
                        />
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="jobTitle"
                            id="jobTitle"
                            label="Primary Contact Job Title*"
                            v-model="newUser.jobTitle"
                            :invalid-feedback="errors['jobTitle'] || 'Required'"
                            :is-valid="
                                isLengthValid(
                                    newUser.jobTitle,
                                    MAX_LENGTHS.jobTitle
                                ) && !errors.hasOwnProperty('jobTitle')
                            "
                            required
                            @input="delete errors.jobTitle"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="businessCategory"
                            id="businessCategory"
                            label="Business Category*"
                            v-model="newUser.businessCategory"
                            :invalid-feedback="
                                errors['businessCategory'] || 'Required'
                            "
                            :is-valid="
                                isLengthValid(
                                    newUser.businessCategory,
                                    MAX_LENGTHS.businessCategory
                                ) && !errors.hasOwnProperty('businessCategory')
                            "
                            required
                            @input="delete errors.businessCategory"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="phone"
                            id="phone"
                            label="Primary Phone Number*"
                            v-model="newUser.phone"
                            :invalid-feedback="errors['phone'] || 'Required'"
                            :is-valid="
                                isLengthValid(
                                    newUser.phone,
                                    MAX_LENGTHS.phone
                                ) && !errors.hasOwnProperty('phone')
                            "
                            required
                            @input="delete errors.phone"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="companyName"
                            id="companyName"
                            label="Business/Company Name*"
                            v-model="newUser.companyName"
                            :invalid-feedback="
                                errors['companyName'] || 'Required'
                            "
                            :is-valid="
                                isLengthValid(
                                    newUser.companyName,
                                    MAX_LENGTHS.companyName
                                ) && !errors.hasOwnProperty('companyName')
                            "
                            required
                            @input="delete errors.companyName"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            label="Business Website"
                            v-model="newUser.website"
                            :invalid-feedback="errors['website']"
                        ></CInput>
                    </CCol>
                </CRow>
                <h3>Business Address</h3>
                <CRow>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="street"
                            id="street"
                            label="Street*"
                            v-model="newUser.street"
                            :invalid-feedback="errors['street'] || 'Required'"
                            :is-valid="
                                isLengthValid(
                                    newUser.street,
                                    MAX_LENGTHS.street
                                ) && !errors.hasOwnProperty('street')
                            "
                            required
                            @input="delete errors.street"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            label="Street 2"
                            v-model="newUser.street2"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="city"
                            id="city"
                            label="City*"
                            v-model="newUser.city"
                            :invalid-feedback="errors['city'] || 'Required'"
                            :is-valid="
                                isLengthValid(newUser.city, MAX_LENGTHS.city) &&
                                    !errors.hasOwnProperty('city')
                            "
                            required
                            @input="delete errors.city"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <label class="">Country*</label>
                        <CSelect
                            ref="country"
                            id="country"
                            horizontal
                            :options="countries"
                            :value.sync="newUser.country"
                            placeholder="Please select"
                            :invalid-feedback="errors['country'] || 'Required'"
                            :is-valid="
                                isLengthValid(
                                    newUser.country,
                                    MAX_LENGTHS.country
                                ) && !errors.hasOwnProperty('country')
                            "
                            required
                            @input="delete errors.country"
                            @change="handleCountryChange"
                        />
                    </CCol>
                    <CCol sm="12" md="6">
                        <CInput
                            ref="zip"
                            id="zip"
                            label="Zip Code*"
                            v-model="newUser.zip"
                            :invalid-feedback="errors['zip'] || 'Required'"
                            :is-valid="
                                isLengthValid(newUser.zip, MAX_LENGTHS.zip) &&
                                    !errors.hasOwnProperty('zip')
                            "
                            required
                            @input="delete errors.zip"
                        ></CInput>
                    </CCol>
                    <CCol sm="12" md="6">
                        <label class="">State/Province/Region*</label>
                        <CSelect
                            ref="state"
                            id="state"
                            horizontal
                            :options="states"
                            :value.sync="newUser.state"
                            placeholder="Please select"
                            :invalid-feedback="errors['state'] || 'Required'"
                            :is-valid="
                                isLengthValid(
                                    newUser.state,
                                    MAX_LENGTHS.state
                                ) && !errors.hasOwnProperty('state')
                            "
                            required
                            @input="delete errors.state"
                        />
                    </CCol>
                </CRow>

                <h3>Interests</h3>
                <p>Product Line(s)*</p>
                <p>
                    <CInputCheckbox
                        label="Select/Deselect All"
                        custom
                        name="allInterests"
                        :checked="
                            newUser.interests.length == productLines.length
                        "
                        @change="toggleInterestsSelected"
                    />
                </p>
                <CRow form class="form-group">
                    <CCol
                        ref="interests"
                        md="4"
                        v-for="(option, optionIndex) in productLines"
                        :key="option"
                    >
                        <CInputCheckbox
                            :label="option"
                            :value="option"
                            custom
                            :name="`Option ${optionIndex}`"
                            :checked="newUser.interests.indexOf(option) != -1"
                            :invalid-feedback="errors['interests'] || ''"
                            :is-valid="newUser.interests.length > 0"
                            @change="changeProductLinesSelected"
                        />
                    </CCol>
                </CRow>

                <p>Comments</p>
                <CTextarea
                    v-model="newUser.comments"
                    placeholder="Comments..."
                    horizontal
                />
                <p>Please check the following boxes.*</p>
                <CRow form class="form-group">
                    <CCol>
                        <CInputCheckbox
                            ref="MinimumOrder"
                            id="MinimumOrder"
                            label="I understand that a $5,000.00 minimum opening order is required."
                            :value="true"
                            custom
                            name="MinimumOrder"
                            :invalid-feedback="
                                termsError.MinimumOrder || 'Required'
                            "
                            :is-valid="isNull(termsError.MinimumOrder)"
                            required
                            @change="changeTermsSelected"
                        />
                    </CCol>
                </CRow>
                <CRow form class="form-group">
                    <CCol>
                        <CInputCheckbox
                            ref="Fob"
                            id="Fob"
                            label="I understand that pricing is FOB based (Chicago/Batavia)."
                            :value="true"
                            custom
                            name="Fob"
                            :invalid-feedback="termsError.Fob || 'Required'"
                            :is-valid="isNull(termsError.Fob)"
                            required
                            @change="changeTermsSelected"
                        />
                    </CCol>
                </CRow>
                <CRow form class="form-group">
                    <CCol>
                        <CInputCheckbox
                            ref="BaseCost"
                            id="BaseCost"
                            label="Suncast does not offer tiered or volume pricing discounts, we set a base cost for each sku."
                            :value="true"
                            custom
                            name="BaseCost"
                            :invalid-feedback="
                                termsError.BaseCost || 'Required'
                            "
                            :is-valid="isNull(termsError.BaseCost)"
                            required
                            @change="changeTermsSelected"
                        />
                    </CCol>
                </CRow>
                <CRow form class="form-group">
                    <CCol>
                        <CInputCheckbox
                            ref="Credit"
                            id="Credit"
                            label="I understand that credit terms are subject to Suncast approval."
                            :value="true"
                            custom
                            name="Credit"
                            :invalid-feedback="termsError.Credit || 'Required'"
                            :is-valid="isNull(termsError.Credit)"
                            required
                            @change="changeTermsSelected"
                        />
                    </CCol>
                </CRow>
                <h3>Upload the following documents</h3>
                <CRow form class="form-group">
                    <CCol>
                        <CInputFile
                            ref="t9"
                            label="Upload T9 form here"
                            horizontal
                            id="t9"
                            v-on:change="requiredDocsList"
                            :invalid-feedback="filesError.t9 || 'Required'"
                            :is-valid="isNull(filesError.t9)"
                            required
                        />
                    </CCol>
                </CRow>
                <CRow form class="form-group">
                    <CCol>
                        <CInputFile
                            ref="taxexempt"
                            label="Upload Tax exempt form here"
                            horizontal
                            id="taxexempt"
                            v-on:change="requiredDocsList"
                            :invalid-feedback="
                                filesError.taxexempt || 'Required'
                            "
                            :is-valid="isNull(filesError.taxexempt)"
                            required
                        />
                    </CCol>
                </CRow>
                <CCardFooter>
                    <vue-recaptcha
                        ref="recaptcha"
                        @verify="onCaptchaVerified"
                        @expired="onCaptchaExpired"
                        size="invisible"
                        badge="inline"
                        sitekey="6LeQrbIZAAAAAGDBzorDwWvYdPnNzVjMP7Op_nOp"
                    >
                    </vue-recaptcha>
                    <CRow>
                        <CCol sm="6">
                            <CButton
                                color="primary"
                                class="px-4 mt-2"
                                type="submit"
                                :disabled="status === 'submitting'"
                                >Register</CButton
                            >
                        </CCol>
                        <CCol sm="6">
                            <CButton
                                color="secondary"
                                @click="goBack"
                                class="float-right mt-2"
                                >Cancel</CButton
                            >
                        </CCol>
                    </CRow>
                </CCardFooter>
            </CForm>
            <div class="success" v-if="saveSuccess">
                <p>Registration Process Complete</p>
                <CButton color="primary" @click="goBack"
                    >Return to Login</CButton
                >
            </div>
        </div>
    </CContainer>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import portalapi from "../../../../services/portalapi";
import { generalForm } from "../../../../services/validators";
import VueRecaptcha from "vue-recaptcha";

const VALIDATION_MAX_LENGTHS = {
    firstName: 50,
    lastName: 50,
    jobTitle: 100,
    businessCategory: 50,
    email: 256,
    userName: 100,
    phone: 30,
    companyName: 100,
    website: 100,
    street: 100,
    city: 100,
    state: 50,
    country: 50,
    zip: 20,
    comments: 200
};

export default {
    name: "AccountRegistration",
    components: {
        "vue-recaptcha": VueRecaptcha
    },
    data() {
        return {
            status: "",
            MAX_LENGTHS: VALIDATION_MAX_LENGTHS,
            errors: {},
            registrationId: null,
            termsError: {
                Fob: "Please check this box",
                MinimumOrder: "Please check this box",
                Credit: "Please check this box",
                BaseCost: "Please check this box"
            },
            filesError: {
                t9: "Please upload this file ",
                taxexempt: "Please upload this file "
            },
            newUser: {
                firstName: null,
                lastName: null,
                jobTitle: null,
                businessCategory: null,
                email: null,
                userName: null,
                phone: null,
                companyName: null,
                website: null,
                street: null,
                city: null,
                state: null,
                country: null,
                zip: null,
                interests: [],
                comments: null
            },
            documentsUploaded: { t9: null, taxexempt: null },
            fileResult: {
                t9: false,
                taxexempt: false
            },
            states: null,
            countries: null,
            productLines: [
                "Lawn/Garden",
                "Deck Boxes",
                "Outdoor Storage",
                "Outdoor Furniture",
                "Snow Tools",
                "Pet Products",
                "Hose Reel",
                "Home Storage",
                "Commercial"
            ]
        };
    },
    computed: {
        saveSuccess() {
            return this.fileResult.t9 && this.fileResult.taxexempt;
        }
    },
    async mounted() {
        // Initialize the page
        await this.init();
    },
    methods: {
        ...mapGetters("User", ["getCountryList", "getStateList"]),
        ...mapActions("User", ["fetchCountries", "fetchStates"]),
        ...generalForm, // mapping functions from generalForm object in validators.js
        //
        // Initialize the page
        //
        async init() {
            // Load the countries select first - it's usually needed first and isn't dependant on userData fetched below
            this.loadCountrySelect();

            // Load the states/provinces, selecting if a country has been selected
            this.loadStatesSelect();
        },
        goBack() {
            this.usersOpened
                ? this.$router.go(-1)
                : this.$router.push({ path: "/pages/login" });
        },
        changeProductLinesSelected(payload) {
            let index = this.newUser.interests.indexOf(payload.target.value);
            if (payload.target.checked) {
                // selected the option
                if (index == -1) {
                    //new entry
                    // if checked add
                    this.newUser.interests.push(payload.target.value);
                }
            } else {
                if (index !== -1) {
                    this.newUser.interests.splice(index, 1);
                }
            }
        },
        // Check/Uncheck all Interests checkboxes
        toggleInterestsSelected(e) {
            let selectedInterests = e.target.checked
                ? [...this.productLines]
                : [];
            this.newUser.interests = selectedInterests;
        },
        changeTermsSelected(payload) {
            let key = payload.target.name;
            if (payload.target.checked) {
                this.termsError[key] = null;
            } else {
                this.termsError[key] = "Please check this box";
            }
        },

        requiredDocsList(e) {
            let key = event.target.id;
            //check if non empty
            if (e.length) {
                this.documentsUploaded[key] = e[0];
                //unset error
                this.filesError[key] = null;
            }
            //empty input
            else {
                //set the file to null
                this.documentsUploaded[key] = null;
                //set error back
                this.filesError[key] = "Please upload this file";
            }
        },
        //returns true if null
        checkIfNull(data) {
            for (const item in data) {
                let key = item;
                if (data[key]) return false;
            }
            return true;
        },
        /**
         * Send file over and update fileResult variable
         */
        async sendFiles(data, type) {
            var response = await portalapi.appPortal.documentsAdd(data);
            if (response.data.success) {
                this.fileResult[type.toLowerCase()] = true;
            }
        },

        onCaptchaVerified: function(recaptchaToken) {
            this.status = "submitting";
            this.$refs.recaptcha.reset();
            this.tryRegister(recaptchaToken);
        },
        onCaptchaExpired: function() {
            this.$refs.recaptcha.reset();
        },
        onSubmit() {
            if(this.newUser.interests.length == 0) {
                this.$toast.open({
                    message: "Please select one or more interests",
                    type: "error"
                });
                return;
            }
                this.$refs.recaptcha.execute();
        },
        /**
         * Register the new user
         */
        async tryRegister(recaptchaToken) {
            // Call API if no terms and conditions still left to check and no files left to upload
            if (
                this.checkIfNull(this.termsError) &&
                this.checkIfNull(this.filesError)
            ) {
                //convert Client interest array into string
                this.newUser.interests = this.newUser.interests.toString();
                this.newUser.recaptchaToken = recaptchaToken;
                // try Registering
                var response = await portalapi.appPortal.registerAdd(
                    this.newUser
                );
                // check if successfully registered
                if (response.status == 200 && response.data.success) {
                    this.registrationId = response.data.registration.id;
                    //Call function sendFiles 2 times and update the fileResult variable
                    for (const row in this.documentsUploaded) {
                        let key = row;
                        let data = new FormData();
                        data.append("registrationId", this.registrationId);
                        data.append("file", this.documentsUploaded[key]);
                        //IMPORTANT! - key should be in uppercase because API only accepts T9  TAXEXEMPT only
                        data.append("type", key.toUpperCase());
                        await this.sendFiles(data, key);
                    }
                }
                //error while registering
                else {
                    this.status = "";
                    //Set error messages in ui from api response
                    this.errors = response.data.errors;
                    this.$toast.open({
                        message: "Please check the required inputs",
                        type: "error"
                    });
                    this.setFocus(this.errors);
                }
            } else {
                this.status = "";
                this.errors = { ...this.termsError, ...this.filesError };
                this.$toast.open({
                    message: "Please check the required inputs",
                    type: "error"
                });
                this.setFocus(this.errors);
            }
        },
        /**
         * Set Focus onto the first input element in the error list
         */
        setFocus(error) {
            let inx = Object.getOwnPropertyNames(error);
            var element = document.getElementById(inx[0]);
            element.focus();
        },
        //
        // Load the countries & the select box options
        //
        async loadCountrySelect() {
            let countries = this.getCountryList();

            // Don't have them yet - fetch and try again
            if (countries == null || countries.length == 0) {
                await this.fetchCountries();
                countries = this.getCountryList();
            }

            // Load the countries into the select box & enable it
            this.countries = countries;
        },
        //
        // Load the states/provinces & the select box options
        //
        async loadStatesSelect() {
            let statesAndProvinces = this.getStateList();

            // Don't have them yet - fetch and try again
            if (statesAndProvinces == null || statesAndProvinces.length == 0) {
                await this.fetchStates();
                statesAndProvinces = this.getStateList();
            }

            // Load the selected country's states/provinces into the select box if a country has been selected
            if (this.newUser.country != null) {
                this.states = statesAndProvinces[this.newUser.country];
            }
        },
        //
        // Populate the state/province select box
        //
        handleCountryChange() {
            this.newUser.state = null;

            // Populate the states/provinces select box
            this.loadStatesSelect();
        }
    }
};
</script>

<style scoped></style>
